<template>
  <div class="container">
      <!-- <span>{{newCharger}}</span>
      <span>{{ transferVal }}</span> -->
      <a-modal class="gufiiguy" :title="replaceTypes == 1? '替换责任人' : '确认移交'" :visible="replaceVisible" @cancel="closeVisible" @ok="receive" width="80%">
             <div class="headline"> 物品信息 </div>
             <div class="scrap_body">
                <DepartSelect :replaceTypes="replaceTypes" @getCharger="getCharger" :allform="allform" ref="departSelectRef"></DepartSelect>
              <a-form-model :model="scrapForm" :rules="rules" ref="ruleForm" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                    <a-row v-if="replaceTypes == 1">
					    <a-form-model-item>
                            <a-table :columns="columns" :data-source="val"/>                      
                               <!-- :data="ccC"@targetKeys="getdata" v-if="isRouterAlive"  -->
					    </a-form-model-item>
				    </a-row>
                    <a-row v-else>
					    <a-form-model-item >
                             <a-table :columns="columns1" :data-source="transferVal" />                      
                               <!-- :data="ccC"@targetKeys="getdata" v-if="isRouterAlive"  -->
					    </a-form-model-item>
				    </a-row>
            </a-form-model>

          </div>
            
      </a-modal>
  </div>
</template>
<script>
import DepartSelect from '@/components/module/departSelect.vue'
import { types } from '@babel/core' 
import { replaceDuty_put, trans , assetTrans} from '@/api/Industry'
import { storage_transfe } from '@/api/purchase'
import { axios } from '@/utils/request'
export default {
    components: {
        DepartSelect,

    },
    props: ['replaceTypes', 
    'replaceVisible',
    'val',
    'transferVal'],
    data() {
        return {
            department: '',
            name: '',
            newCharger: '',
            receiveList: [],
            allform: {
                department: '',
                name: ''
            },
               columns: [
                 {
                    title: '所属部门',
                    dataIndex: 'belongDept',
                },
                {
                    title: '资产类别',
                    dataIndex: 'assetTypeName',
                },
               {
                    title: '物品编号',
                    dataIndex: 'assetSn',
               },
                {
                    title: '物品状态',
                    dataIndex: 'goodStatus',
                },
                 {
                    title: '物品名称',
                    dataIndex: 'name',
                },
                 {
                    title: '规格型号',
                    dataIndex: 'model',
                },
                 {
                    title: '物品单价',
                    dataIndex: 'singlePrice',
                },
            ],
               columns1: [
                 {
                    title: '物品编号',
                    dataIndex: 'assetSn',
                },
                {
                    title: '资产类别',
                    dataIndex: 'assetTypeName',
                },
                {
                    title: '物品状态',
                    dataIndex: 'goodStatus',
                },
                 {
                    title: '物品名称',
                    dataIndex: 'name',
                },
                 {
                    title: '规格型号',
                    dataIndex: 'model',
                },
                 {
                    title: '物品单价',
                    dataIndex: 'singlePrice',
                },
            ]
        }
    },
    methods: {
        closeVisible() {
             
            this.replaceVisible = false
            // this.allform.department = '',
            // this.allform.name = '',
            this.$refs.departSelectRef.$refs.allformRef.resetFields()
            this.$emit("visibleState",{
                  replaceVisible: this.replaceVisible,
                  val: [],
                  selectedRowKeys: []
            })
            // this.$refs.departSelectRef.$refs.allformRef.resetFields()
        },
        getCharger(data) {
            // console.log(Charger, 'Charger============================')
            this.newCharger = data.newCharger
            
            // this.allform.name = Charger
        },
        receive() {
            console.log(this.$refs.departSelectRef, 'this.$refs.departSelectRef')
            //表单校验
            this.$refs.departSelectRef.$refs.allformRef.validate((valid) => {
					if (valid) {
              if(this.replaceTypes == 1) {
                 let newVal = this.val.map(item=>{
                  // 每一项的id
                  return item.id
                })
            this.replaceVisible = false
                 replaceDuty_put({
                ids: newVal,
                newCharger: this.newCharger
            }).then(res => {
                if(res.code == 200){
                    this.val = []
                    this.allform.department = ''
                    this.allform.name = ''

                    this.$refs.departSelectRef.$refs.allformRef.resetFields()
                    this.$message.success(res.msg);
                    

                } else {
                    this.$message.error(res.msg);
                }
             console.log(res, 'res++++++++++++++++++++++++++++++')
            })
            console.log(this.val, 'this.val============')
                    console.log(this.allform, 'this.allform============')
            this.$emit("visibleState", {
                replaceVisible: this.replaceVisible,
                val: this.val,
                selectedRowKeys: []
            })
            //刷新列表
            this.$emit('put')
            } else if(this.replaceTypes == 0){
                 console.log(this.replaceTypes,'1111111111111111111111111111111111111111')
            //    axios({
            //        url: `/daily/asset/trans?assetId=${this.transferVal[0].id}&userName=${this.newCharger}`,
            //        method: 'put',
            //    })
              let transferVal = this.transferVal.map(item=>{
                  // 每一项的id
                  return item.id
                })
            assetTrans({
                userName: this.newCharger,
                assetId: transferVal
            }).then(res => {
                   console.log(res, 'res6666666666666666666666666===================')
                if(res.code == 200){
                    this.transferVal = []
                    // this.allform = []
                     this.allform.department = ''
                    this.allform.name = ''
                    this.$refs.departSelectRef.$refs.allformRef.resetFields()
                    this.$message.success('移交成功！')
                    this.replaceVisible = false
                 this.$emit("visibleState", {
                replaceVisible: this.replaceVisible,
                val: this.transferVal,
                selectedRowKeys: []
                 })
                } else {
                    this.$message.error('移交失败！');
                }
            //刷新列表
            this.$emit('put')
             console.log(res, 'res++++++++++++++++++++++++++++++')
            })
            }

                    }

            })
            
          
            
           


        },
    
    },
   
   
    // props: [
    // "replaceTypes" //这里指定了字符串类型，如果类型不一致会警告的哦
    //  ]

}
</script>

<style>
.scrap_body {
    background-color: #f8f8f8;
    padding: 20px 10px 10px;
     font-size: 20px;
}
.headline {
    font-size: 20px;
    margin: 20px;
}

</style>
